import { GlobalAxios } from "../axios/axios-config";
import {
  IMarComAutomationCategories,
  INewMarComAutomationCategories,
} from "../models/mar-com-automation-categories";

const CAMPAIGN_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationCategory";

export const createMarComAutomationCategory = (
  params: INewMarComAutomationCategories
) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getMarComAutomationCategoryById = (id: string) => {
  return GlobalAxios.get<IMarComAutomationCategories>(
    CAMPAIGN_ROUTE + "/" + id
  );
};

export const updateMarComAutomationCategory = ({
  id,
  item,
}: {
  id: string;
  item: INewMarComAutomationCategories;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + "/" + id, item);
};
